import React from 'react';
import './ThatchingandAerationDetails.css';

const thatchingAndAerationServices = [
  {
    title: 'Dethatching',
    description:
      'We remove the layer of thatch made up of dead grass, roots, and organic debris. This layer can block water, air, and nutrients from reaching the soil. Removing it allows your lawn to breathe and absorb what it needs.',
  },
  {
    title: 'Core Aeration',
    description:
      'We remove small plugs of soil across the lawn to reduce compaction. This allows better movement of air, water, and nutrients into the root zone and encourages stronger root development.',
  },
  {
    title: 'Cleanup',
    description:
      'After dethatching and aeration, we remove any loose material, plugs, and debris left on the surface. A clean surface improves seed contact with the soil and leads to better germination.',
  },
  {
    title: 'Topsoil Application',
    description:
      'We apply a light layer of screened topsoil to improve the structure and fertility of the soil. This creates a healthier growing environment and helps level out uneven areas.',
  },
  {
    title: 'Grass Seeding',
    description:
      'We apply grass seed selected for your climate and conditions. Overseeding helps fill in bare spots, crowd out weeds, and build a thicker, more uniform lawn.',
  },
  {
    title: 'Peat Moss Application',
    description:
      'We spread a thin layer of peat moss over newly seeded areas. This helps hold moisture, protects the seed from wind and birds, and supports consistent germination.',
  },
];

export default function ThatchingandAerationDetails() {
  return (
    <section className="ThatchingandAerationDetails">
      <div className="ThatchingandAerationDetails__container">
        <header className="ThatchingandAerationDetails__main-header">
          <h2 className="ThatchingandAerationDetails__main-title">Lawn Recovery</h2>
             <div className="rl-title-underline"></div>
          <p className="ThatchingandAerationDetails__main-description">
            This one-time service is for lawns that are thin, compacted, patchy, or have not been
            consistently maintained. It includes six steps to restore healthy conditions in the soil
            and turf, supporting better growth and long-term improvement. Pricing starts at $500.
            Final cost is based on lawn size and overall condition.
          </p>
        </header>

        <div className="ThatchingandAerationDetails__services">
          {thatchingAndAerationServices.map((service, idx) => (
            <div key={idx} className="ThatchingandAerationDetails__service">
              <div className="ThatchingandAerationDetails__service-content">
                <h2 className="ThatchingandAerationDetails__service-title">{service.title}</h2>
                <div className="ThatchingandAerationDetails__service-description">
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Final Thoughts Section */}
        <div className="ThatchingandAerationDetails__final-thoughts">
          <h2 className="ThatchingandAerationDetails__final-title">Ready to bring your lawn back to life?</h2>
          <p className="ThatchingandAerationDetails__final-description">
            Our <strong>six-step </strong>recovery service improves soil health, encourages stronger roots, and helps your lawn grow in thick and green. Pricing starts at $500. .
          </p>
<a href="/contact" className="ThatchingandAerationDetails__contact-button">
  Get Your Free Quote
</a>
        </div>
      </div>
    </section>
  );
}
